import React from "react";
import { CartProvider } from "./CartContext";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useRoutes,
} from "react-router-dom";
// import Comingsoon from "./pages/sitepages/Comingsoon";
import Home from "./pages/sitepages/Home";
import AboutUs from "./pages/sitepages/AboutUs";
import Feedbacks from "./pages/sitepages/Feedbacks";
import HoroscopesAll from "./pages/sitepages/HoroscopesAll";
import Blogs from "./pages/sitepages/Blogs";
import Search from "./pages/sitepages/Search";
import Error from "./pages/sitepages/Error";
import Registration from "./pages/sitepages/Registration";
import OtpLogin from "./pages/sitepages/OtpLogin";
import DashboardUser from "./pages/sitepages/DashboardUser";
import DashboardUserEmail from "./pages/sitepages/DashboardUserEmail";
import DashboardUserVerification from "./pages/sitepages/DashboardUserVerification";
import Login from "./pages/sitepages/Login";
import AstrologerReg from "./pages/sitepages/AstrologerReg";
import DashboardAstrologer from "./pages/sitepages/DashboardAstrologer";
import AstrologerLogin from "./pages/sitepages/AstrologerLogin";
import DashboardAstroProfile from "./pages/sitepages/DashboardAstroProfile";
import DashboardAstroLanguages from "./pages/sitepages/DashboardAstroLanguages";
import DashboardAstroServices from "./pages/sitepages/DashboardAstroServices";
import DashboardAstroPhotograph from "./pages/sitepages/DashboardAstroPhotograph";
import DashboardAstroPic from "./pages/sitepages/DashboardAstroPic";
import DashboardAstroOtp from "./pages/sitepages/DashboardAstroOtp";
import DashboardAstroEmail from "./pages/sitepages/DashboardAstroEmail";
import DashboardAstroVerification from "./pages/sitepages/DashboardAstroVerification";
import AstrologerPassword from "./pages/sitepages/AstrologerPassword";
import UserPassword from "./pages/sitepages/UserPassword";

import DashboardAstroSlots from "./pages/sitepages/DashboardAstroSlots";

import ForgotPassword from "./pages/sitepages/ForgotPassword";
import ResetPassword from "./pages/sitepages/ResetPassword";
import ForgotPasswordAstrologer from "./pages/sitepages/ForgotPasswordAstrologer";
import ResetPasswordAstrologer from "./pages/sitepages/ResetPasswordAstrologer";

import PrivacyPolicy from "./pages/sitepages/PrivacyPolicy";
import RefundPolicy from "./pages/sitepages/RefundPolicy";
import ShippingPolicy from "./pages/sitepages/ShippingPolicy";
import UsageTerms from "./pages/sitepages/UsageTerms";
import LegalPolicy from "./pages/sitepages/LegalPolicy";

import CategoryDetails from "./pages/sitepages/CategoryDetails";
import BlogsByCategory from "./pages/sitepages/BlogsByCategory";
import BlogDetails from "./pages/sitepages/BlogDetails";
import BlogCategory from "./pages/sitepages/BlogCategory";

import Epooja from "./pages/sitepages/Epooja";
import EpoojaDetails from "./pages/sitepages/EpoojaDetails";

import AstroServices from "./pages/sitepages/AstroServices";

import Horoscopes from "./pages/sitepages/Horoscopes";
import CourseScreen from "./pages/sitepages/CourseScreen";

import CourseCategoryDetails from "./pages/sitepages/CourseCategoryDetails";
import Courses from "./pages/sitepages/Courses";
import CourseCategories from "./pages/sitepages/CourseCategories";
import Course from "./pages/sitepages/Course";
import AllCourses from "./pages/sitepages/AllCourses";
import Cart from "./pages/sitepages/Cart";
import PaymentFailed from "./pages/sitepages/PaymentFailed";
import PaymentFailedAstro from "./pages/sitepages/PaymentFailedAstro";
import PaymentSuccess from "./pages/sitepages/PaymentSuccess";
import PaymentProcessing from "./pages/sitepages/PaymentProcessing";
import PaymentProcessingAstro from "./pages/sitepages/PaymentProcessingAstro";
import PaymentProcessingAstroNew from "./pages/sitepages/PaymentProcessingAstroNew";

import Support from "./pages/sitepages/Support";
import Welcome from "./pages/sitepages/Welcome";
import FAQs from "./pages/sitepages/FAQs";
import Invoice from "./pages/sitepages/Invoice";

import Policyapprove1 from "./pages/sitepages/Policyapprove1";
import Policyapprove2 from "./pages/sitepages/Policyapprove2";

import UserAppointments from "./pages/sitepages/UserAppointments";
import AppointmentInvoice from "./pages/sitepages/AppointmentInvoice";
import AstroAppointments from "./pages/sitepages/AstroAppointments";

import AllAstrologers from "./pages/sitepages/AllAstrologers";
import AstrologersByCategory from "./pages/sitepages/AstrologersByCategory";
import Planner from "./pages/sitepages/Planner";
import Plannerwithouttopics from "./pages/sitepages/Plannerwithouttopics";
import Plannerbtr from "./pages/sitepages/Plannerbtr";
import Plannerhmkr from "./pages/sitepages/Plannerhmkr";
import Scheduler from "./pages/sitepages/Scheduler";
import Schedulernew from "./pages/sitepages/Schedulernew";
import UserDetails_pc from "./pages/sitepages/UserDetails_pc";
import UserDetails_mla from "./pages/sitepages/UserDetails_mla";
import UserDetails_mm from "./pages/sitepages/UserDetails_mm";
import UserDetails_cna from "./pages/sitepages/UserDetails_cna";
import UserDetails_hmkr from "./pages/sitepages/UserDetails_hmkr";
import UserDetails_hmkr_new from "./pages/sitepages/UserDetails_hmkr_new";
import UserDetails_bp from "./pages/sitepages/UserDetails_bp";
import UserDetails_tcr from "./pages/sitepages/UserDetails_tcr";
import UserDetails_n from "./pages/sitepages/UserDetails_n";
import UserDetails_va from "./pages/sitepages/UserDetails_va";
import UserDetails_p from "./pages/sitepages/UserDetails_p";
import UserDetails_fr from "./pages/sitepages/UserDetails_fr";

import UserDetails_ha from "./pages/sitepages/UserDetails_ha";
import UserDetails_sa from "./pages/sitepages/UserDetails_sa";
import UserDetails_btr from "./pages/sitepages/UserDetails_btr";

import AstroPayment from "./pages/sitepages/AstroPayment";
import AstroPaymentnew from "./pages/sitepages/AstroPaymentnew";

import { useEffect } from "react";
import ScrollToTop from "./ScrollToTop";
import { useState } from "react";
import Preloader from "./components/preloader";
import { HelmetProvider } from "react-helmet-async"; 

import ProtectedRoute from "./ProtectedRoute";
import { AuthProvider } from "./AuthContext";

const AppWrapper = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);
  

  return (
       
    <HelmetProvider>
     <CartProvider>
      {!loading ? (
        <AuthProvider>
          <Router>
            <ScrollToTop />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/home" element={<Home />} />
              <Route path="/about" element={<AboutUs />} />
              <Route path="/feedbacks" element={<Feedbacks />} />
              <Route path="/horoscopesall" element={<HoroscopesAll />} />
              <Route path="/astroservices" element={<AstroServices />} />
              <Route path="/blogs" element={<Blogs />} />
              <Route path="/blogcategories" element={<BlogCategory />} />

              <Route path="/registration" element={<Registration />} />
              <Route path="/otplogin" element={<OtpLogin />} />
              <Route path="/login" element={<Login />} />

              
              <Route path="/allastrologers" element={<AllAstrologers />} />
             
              <Route path="/userdashboard" element={<ProtectedRoute element={<DashboardUser />} />} />
                <Route path="/verifyuseremail" element={<ProtectedRoute element={<DashboardUserEmail />} />} />
                <Route path="/verify-user-email/:token" element={<DashboardUserVerification />} />
              
              <Route path="/astrologerreg" element={<AstrologerReg />} />
              <Route path="/astrologerdashboard" element={<ProtectedRoute element={<DashboardAstrologer />} />} />
              <Route path="/astrologerlogin" element={<AstrologerLogin />} />
             <Route path="/completeprofile" element={<ProtectedRoute element={<DashboardAstroProfile />} />} />
             <Route path="/complete-language" element={<ProtectedRoute element={<DashboardAstroLanguages />} />} />
             <Route path="/complete-services" element={<ProtectedRoute element={<DashboardAstroServices />} />} />
             <Route path="/upload-photo" element={<ProtectedRoute element={<DashboardAstroPhotograph />} />} />
             <Route path="/change-photo" element={<ProtectedRoute element={<DashboardAstroPic />} />} />
             <Route path="/verify-number" element={<ProtectedRoute element={<DashboardAstroOtp />} />} />
             <Route path="/verify-email" element={<ProtectedRoute element={<DashboardAstroEmail />} />} />
             <Route path="/verify-astrologer-email/:token" element={<DashboardAstroVerification />} />
             <Route path="/astrologerslots" element={<ProtectedRoute element={<DashboardAstroSlots />} />} />

             <Route path="/astrologerpassword/:id" element={<ProtectedRoute element={<AstrologerPassword />} />} />
             <Route path="/userpassword/:id" element={<ProtectedRoute element={<UserPassword />} />} />

              <Route path="/forgotpassword" element={<ForgotPassword />} />
              <Route path="/reset-password/:resetToken" element={<ResetPassword />} />
              <Route path="/forgotpasswordastrologer" element={<ForgotPasswordAstrologer />} />
              <Route path="/reset-password-astrologer/:resetToken" element={<ResetPasswordAstrologer />} />

              <Route path="/error" element={<Error />} />
              <Route path="*" element={<Error />} />
              <Route path="/search" element={<Search />} />
              <Route path="/privacypolicy" element={<PrivacyPolicy />} />
              <Route path="/refundpolicy" element={<RefundPolicy />} />
              <Route path="/shippingpolicy" element={<ShippingPolicy />} />
              <Route path="/usageterms" element={<UsageTerms />} />
               <Route path="/legalpolicy" element={<LegalPolicy />} />

              <Route path="/category-details/:clientId" element={<CategoryDetails />} />
              <Route path="/blog-category-details/:clientId" element={<BlogsByCategory />} />
              <Route path="/blog-details/:clientId" element={<BlogDetails />} />

              <Route path="/epooja" element={<Epooja />} />
              <Route path="/epooja-details/:clientId" element={<EpoojaDetails />} />

              
              <Route path="/horoscopes/:clientId" element={<Horoscopes />} />

         
              <Route path="/course-screen/:clientId" element={<ProtectedRoute element={<CourseScreen />} />} />
               <Route path="/invoice/:clientId" element={<ProtectedRoute element={<Invoice />} />} />

              <Route path="/course-category-details/:clientId" element={<CourseCategoryDetails />} />
              <Route path="/courses/:clientId" element={<Courses />} />
              <Route path="/coursecategories" element={<CourseCategories />} />
              <Route path="/course/:clientId" element={<Course />} />
              <Route path="/allcourses" element={<AllCourses />} />
            
              <Route path="/cart" element={<Cart />} /> 
               <Route path="/payment-failed" element={<PaymentFailed />} /> 
               <Route path="/payment-failed-astro" element={<PaymentFailedAstro />} /> 
                <Route path="/payment-success" element={<PaymentSuccess />} /> 
                 <Route path="/payment-status" element={<PaymentProcessing />} /> 

                 <Route path="/payment-status-astro" element={<PaymentProcessingAstro />} /> 
                 <Route path="/payment-status-astro-new" element={<PaymentProcessingAstroNew />} /> 

                 <Route path="/support" element={<Support />} /> 
                  <Route path="/journey" element={<Welcome />} /> 
                   <Route path="/faqs" element={<FAQs />} /> 

                  <Route path="/policy1" element={<Policyapprove1 />} /> 
                   <Route path="/policy2" element={<Policyapprove2 />} /> 

                   <Route path="/astrologerbysubcategory/:clientId" element={<AstrologersByCategory />} />
                    <Route path="/planner/:id/:category" element={<Planner />} />
                       <Route path="/plannerwithouttopics/:id/:category" element={<Plannerwithouttopics />} />
                        <Route path="/plannerbtr/:id/:category" element={<Plannerbtr />} />
                          <Route path="/plannerhmkr/:id/:category" element={<Plannerhmkr />} />
                     <Route path="/scheduler/:bookingId" element={<Scheduler />} />
                     <Route path="/schedulernew/:bookingId" element={<Schedulernew />} />
                      <Route path="/userdetails_pc/:reservationId" element={<UserDetails_pc />} />
                        <Route path="/userdetails_mla/:reservationId" element={<UserDetails_mla />} />
                         <Route path="/userdetails_mm/:reservationId" element={<UserDetails_mm />} />
                          <Route path="/userdetails_cna/:reservationId" element={<UserDetails_cna />} />
                           <Route path="/userdetails_hmkr/:reservationId" element={<UserDetails_hmkr />} />
                             <Route path="/userdetails_hmkr_new/:reservationId" element={<UserDetails_hmkr_new />} />
                            <Route path="/userdetails_bp/:reservationId" element={<UserDetails_bp />} />
                             <Route path="/userdetails_tcr/:reservationId" element={<UserDetails_tcr />} />
                              <Route path="/userdetails_n/:reservationId" element={<UserDetails_n />} />
                              <Route path="/userdetails_va/:reservationId" element={<UserDetails_va />} />
                               <Route path="/userdetails_p/:reservationId" element={<UserDetails_p />} />
                               <Route path="/userdetails_fr/:reservationId" element={<UserDetails_fr />} />

                               <Route path="/userdetails_ha/:reservationId" element={<UserDetails_ha />} />
                               <Route path="/userdetails_sa/:reservationId" element={<UserDetails_sa />} />
                                <Route path="/userdetails_btr/:reservationId" element={<UserDetails_btr />} />

                                 <Route path="/payment/:id" element={<AstroPayment />} />
                                 <Route path="/paymentnew/:id" element={<AstroPaymentnew />} />

                                  <Route path="/userappointments/:bookingId" element={<ProtectedRoute element={<UserAppointments />} />} />
                                   <Route path="/appointmentinvoice/:bookingId" element={<ProtectedRoute element={<AppointmentInvoice />} />} />
                                    <Route path="/astroappointments/:bookingId" element={<ProtectedRoute element={<AstroAppointments />} />} />

            </Routes>
          </Router>
        </AuthProvider>
      ) : (
        <Preloader />
      )}
      </CartProvider>
    </HelmetProvider>
  );
};


export default AppWrapper;
